import {useEffect, useState} from "react";
import {Navigate, useLocation} from "react-router-dom";
import {getBrands} from "@zaaaz/shared";
import {ProductListing} from "@/components/shop/ProductListing";

export function BrandPageClient() {
  const {pathname} = useLocation();
  const legacy = pathname.match(/^\/brand\/(\d+)\/([^/?#]+)/);
  const m = pathname.match(/^\/brand\/([^/?#]+)/);
  const slug = m?.[1] ? decodeURIComponent(m[1]) : "";
  const fallbackTitle = slug ? slug.replace(/-/g, " ") : "Brand";
  const [title, setTitle] = useState(fallbackTitle);
  useEffect(() => {
    setTitle(fallbackTitle);
    if(!slug) return;
    getBrands()
      .then((r) => {
        const brand = r.items.find((row) => row.slug === slug);
        if(brand) setTitle(brand.nume);
      })
      .catch(() => {});
  }, [slug, fallbackTitle]);
  if(legacy) return <Navigate to={`/brand/${legacy[2]}`} replace />;
  return <ProductListing params={{list: slug ? `brand:${slug}` : "brand:"}} title={title} />;
}
